<template>
  <TransitionGroup
    tag="ul"
    class="overflow-y-auto flex-grow scrollbar flex flex-col"
    enter-class="-translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="hidden"
  >
    <li
      v-for="conversation in conversations"
      :conversation="conversation"
      :key="conversation.id"
      class="-mt-1 border-t border-b border-gray-200 transform duration-300"
      v-observe-visibility="(isVisible, entry) => convoVisibilityChanged(isVisible, entry, conversation.id)"
    >
      <router-link
        :to="{name: 'homeNumber', params: {homeNumberId: homeNumberId(conversation)}}"
        class="block bg-white hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
        exact-active-class="text-gray-900 bg-gray-100 focus:bg-gray-200"
      >
        <div class="px-4 py-4 sm:px-6">
          <div class="flex items-center justify-between">
            <div class="text-sm leading-5 font-medium text-cardstock-blue-600 truncate">
              {{label(conversation)}}
            </div>
            <div class="ml-2 flex-shrink-0 flex">
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                :class="[ conversation.hasUnreads ? 'bg-blue-100 text-blue-800' : 'text-gray-500' ]"
              >
                {{conversation.formattedMessagedAt}}
              </span>
            </div>
          </div>
          <div class="mt-2 sm:flex sm:justify-between">
            <div class="mr-6 flex items-center text-sm leading-5 text-gray-500 truncate">
              {{conversation.mostRecentCommunication}}&nbsp;
            </div>
          </div>
        </div>
      </router-link>
    </li>
  </TransitionGroup>
</template>

<script>
import _get from 'lodash/get'
import _nth from 'lodash/nth'

export default {

  props: {
    conversations: {
      type: Array,
      default: () => { [] }
    },
    didLoadMore: {
      type: Function,
      default: () => { console.warn("Cardstock: [warn] unhandled didLoadMore in ConversationList") }
    }
  },

  computed: {
    lastId() {
      return _get(_nth(this.conversations, -1), 'id')
    },

    loadMoreTriggerId() {
      return _get(_nth(this.conversations, -1), 'id')
    }
  },

  methods: {
    convoVisibilityChanged(isVisible, entry, id) {
      if ((isVisible && id == this.loadMoreTriggerId) || (isVisible && id == this.lastId)) {
        this.didLoadMore()
      }
    },

    formattedNumber(conversation) {
      return _get(conversation, 'homeNumber.formattedNumber')
    },

    label(conversation) {
      return _get(conversation, 'homeNumber.label') || this.formattedNumber(conversation)
    },

    homeNumberId(conversation) {
      return _get(conversation, 'homeNumber.id')
    },

    teamId(conversation) {
      return _get(conversation, 'team.id')
    }
  }
}
</script>
